import { DAYS } from '~shared/constants/days';

export function selectedClassDays(value: string): string[] {
  if (!value || value === 'All') {
    return [];
  }
  const allowed = new Set<string>(DAYS);
  return value
    .split(',')
    .map((day) => day.trim())
    .filter((day) => allowed.has(day));
}

export function toggleClassDay(value: string, day: string): string {
  const selected = new Set(selectedClassDays(value));
  if (selected.has(day)) {
    selected.delete(day);
  } else {
    selected.add(day);
  }
  const ordered = DAYS.filter((weekday) => selected.has(weekday));
  return ordered.length > 0 ? ordered.join(',') : 'All';
}

export function classDayFilterLabel(value: string): string {
  const selected = selectedClassDays(value);
  if (selected.length === 0) {
    return 'All Days';
  }
  return selected.join(', ');
}
